var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-app",
    { class: _vm.accessibilityClasses, attrs: { id: "inspire" } },
    [
      _c("skip-navigation"),
      _vm._v(" "),
      _c(
        "header",
        {
          attrs: {
            id: "main-banner",
            role: "banner",
            "aria-label": "Site header",
          },
        },
        [_c("header-component")],
        1
      ),
      _vm._v(" "),
      _c(
        "v-main",
        {
          class: _vm.getContentClases,
          attrs: {
            id: "main-content",
            app: "",
            "fill-height": "",
            fluid: "",
            role: "main",
          },
        },
        [
          _c(
            "v-container",
            {
              attrs: {
                "fill-height": "",
                "pt-0": "",
                "pb-0": "",
                "pl-0": "",
                "pr-0": "",
                fluid: "",
                "aria-label": "Main content container",
                role: "region",
              },
            },
            [
              _vm._t("default"),
              _vm._v(" "),
              _c("post-dialog", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.dialogPost.slug,
                    expression: "dialogPost.slug",
                  },
                ],
                attrs: {
                  post: _vm.dialogPost,
                  role: "dialog",
                  "aria-modal": "true",
                  "aria-label": _vm.dialogPost.title || "Post details",
                },
              }),
              _vm._v(" "),
              _c("notifications-overlay", {
                attrs: { role: "region", "aria-live": "polite" },
              }),
              _vm._v(" "),
              _c("menu-component", {
                attrs: {
                  role: "complementary",
                  "aria-label": "Quick navigation menu",
                },
              }),
            ],
            2
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("footer-component", { attrs: { role: "contentinfo" } }),
      _vm._v(" "),
      _c("back-to-top-button"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }